import NotFound from '@components/molucules/NotFound';

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
